import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { usePlatformAdminOrganizationsApi } from 'services/admin/usePlatformAdminOrganizationsApi';
import { PlatformAdminOrganization } from 'services/admin/platformAdminOrganization.types';

export const PLATFORM_ADMIN_ORGANIZATIONS_QUERY_KEY = 'platform-admin-organizations';

export const useSearchPlatformAdminOrganizations = (
  search: string,
  page: number,
  count: number
) => {
  const { searchOrganizations, getOrganizationOfferCounts } =
    usePlatformAdminOrganizationsApi();

  return useQuery({
    queryKey: [PLATFORM_ADMIN_ORGANIZATIONS_QUERY_KEY, search, page, count],
    queryFn: async () => {
      const organizationPage = await searchOrganizations(
        search || undefined,
        page,
        count
      );
      const organizationIds = organizationPage.content.map(
        (organization) => organization.organizationId
      );
      const offerCountsResponse =
        await getOrganizationOfferCounts(organizationIds);
      const offerCountByOrganizationId = new Map(
        offerCountsResponse.counts.map((entry) => [
          entry.organizationId,
          entry.offerCount
        ])
      );
      const content: PlatformAdminOrganization[] = organizationPage.content.map(
        (organization) => ({
          ...organization,
          offerCount:
            offerCountByOrganizationId.get(organization.organizationId) ?? 0
        })
      );
      return {
        ...organizationPage,
        content
      };
    },
    placeholderData: keepPreviousData
  });
};
